import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Venta } from "@/shared/types/venta";

export async function getUnpaidVenta(id: string): Promise<Venta> {
    await sleep(1000);
    const response = await api.get("ventas/unpaid/" + id);
    return response.data;
}

export function useGetUnpaidVentaQuery(id: string, queryConfig: QueryConfig<Venta> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getUnpaidVenta(id),
        queryKey: ["ventas", "detail", id],
    })
}

export interface GetUnpaidVentaQueryProps {
    id: string,
    queryConfig?: QueryConfig<Venta>,
    children?: (queryResult: QueryResult<Venta>) => ReactNode
}

export function GetUnpaidVentaQuery({
    id,
    children,
    queryConfig
}: GetUnpaidVentaQueryProps) {
    const queryResult = useGetUnpaidVentaQuery(id, queryConfig);
    return children && children(queryResult);
}